/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios'
import {useCallback, useEffect, useMemo, useState} from 'react'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {
  filterSelector,
  resetFilterDelveryOrders,
  setIsFetchData,
} from '../../../redux/slices/filterSlices'
import {objToParams} from '../../../utils'
import {fetchDeliveryOrders, headers} from '../../../services/fetcher'
import {IDeliveryOrder} from 'src/services/types'
// import {delivery_orders as dummyData} from 'src/data/delivery_orders'

export const useTableDo = () => {
  const {filterDeliveryOrders: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const [tableData, setTableData] = useState<IDeliveryOrder[]>([])
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(true)
  const [isError, setIsError] = useState(false)
  const [numberURL, setNumberURL] = useState([])

  const rowNumber = useMemo(() => {
    const per = filter?.per_page ?? 5
    return page * per - per
  }, [filter, page])

  const onFetchDeliveryOrder = useCallback(() => {
    setLoading(true)
    setIsError(false)

    fetchDeliveryOrders(filter)
      .then((res) => {
        const data = res.data.data
        setTableData(data.data)
        setPage(data.current_page)
        setNumberURL(data.links)
      })
      .catch((err) => setIsError(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filter])

  const onReloadTable = () => {
    dispatch(resetFilterDelveryOrders())
    onFetchDeliveryOrder()
  }

  const paginateNumber = async (url: string) => {
    if (!url) return

    try {
      setLoading(true)
      setIsError(false)

      const token = localStorage.getItem('token') as string
      const credentials = localStorage.getItem('credential') as string
      const endpoint = `${url}&credentials=${credentials}&${objToParams(filter)}`
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })
      const data = res.data.data

      setTableData(data.data)
      setPage(data.current_page)
      setNumberURL(data.links)
    } catch (error) {
      setIsError(true)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const getData = setTimeout(onFetchDeliveryOrder, 1000)
    return () => clearTimeout(getData)
  }, [onFetchDeliveryOrder])

  useEffect(() => {
    return () => {
      onReloadTable()
    }
  }, [])

  return {
    loading,
    isError,
    numberURL,
    rowNumber,
    tableData,
    paginateNumber,
    onReloadTable,
  }
}
